import { render, staticRenderFns } from "./TasksListModal.vue?vue&type=template&id=41960f5f&scoped=true&"
import script from "./TasksListModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./TasksListModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41960f5f",
  null
  
)

export default component.exports